import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';

import UserAgreement from '@sophocles/components/staticComponents/UserAgreement';
import { acknowledgeDisabledEmailSettings, agreeToUserAgreement } from '@sophocles/features/auth/authActions';
import DisabledUserEmailNotifications from '@sophocles/views/auth/dialogs/DisabledUserEmailNotifications';
import UserAcknowledgementDialog from '@sophocles/views/auth/dialogs/UserAcknowledgementDialog';

const UserActionBlockersContainer = ({ user, agreeToTerms, acknowledgeDisabledEmail }) => {
  const userId = user.get('id', 0);

  const agreementSignedTime = user.getIn(['options', 'agreement_signed_time'], null);
  // Users must sign agreement if they haven't signed it since launch
  const mustSignAgreement = !agreementSignedTime || moment(agreementSignedTime).isBefore(moment('2017-09-22'));

  const emailDisabledTime = user.getIn(['options', 'autodisabled_emails_timestamp'], null);
  const userOptionId = user.getIn(['options', 'id'], null);

  if (mustSignAgreement) {
    return (
      <UserAcknowledgementDialog
        title="Must Accept User Agreement"
        buttonLabel="I Accept"
        confirm={() => agreeToTerms(userId)}
      >
        <UserAgreement />
      </UserAcknowledgementDialog>
    );
  }
  if (emailDisabledTime) {
    return (
      <UserAcknowledgementDialog
        title="User Email Notifications Disabled"
        buttonLabel="Confirm"
        confirm={() => acknowledgeDisabledEmail(userOptionId)}
      >
        <DisabledUserEmailNotifications
          disabledTime={emailDisabledTime}
          confirm={() => acknowledgeDisabledEmail(userOptionId)}
        />
      </UserAcknowledgementDialog>
    );
  }
  return null;
};

function mapStateToProps(state) {
  return {
    disabledNotifications: state.authentication.disabledNotifications,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    agreeToTerms: user => dispatch(agreeToUserAgreement(user)),
    acknowledgeDisabledEmail: userOption => dispatch(acknowledgeDisabledEmailSettings(userOption)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserActionBlockersContainer);
